// extracted by mini-css-extract-plugin
module.exports = {"inStock":"az_RLc"};